/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Tool_Saved_GenericInputs */



/**
* | output |
* | --- |
* | "Saved to memory" |
*
* @param {Memory_Tool_Saved_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_tool_saved_generic = /** @type {((inputs?: Memory_Tool_Saved_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Tool_Saved_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Im Gedächtnis gespeichert")
	return /** @type {LocalizedString} */ ("Saved to memory")
});